import { ICurrencyState } from '@/store/currency';
import { ICurrencyMutations } from './mutations.types';
import { ICurrencyData } from '@/models';

export const mutations: ICurrencyMutations = {
  SET_CURRENCIES(state: ICurrencyState, payload: ICurrencyData[]): void {
    state.currencies = payload;
  },

  ADD_CURRENCY(state: ICurrencyState, payload: ICurrencyData): void {
    state.currencies.push(payload);
  },

  UPDATE_CURRENCY(state: ICurrencyState, payload: ICurrencyData): void {
    const index = state.currencies.findIndex(
      (currency: ICurrencyData) => currency.id === payload.id
    );

    state.currencies.splice(index, 1, payload);
  },

  REMOVE_CURRENCY(state: ICurrencyState, payload: number): void {
    const index = state.currencies.findIndex(
      (currency: ICurrencyData) => currency.id === payload
    );

    state.currencies.splice(index, 1);
  }
};
